export default __webpack_public_path__ + "static/media/friendsNcake_w640.547e1435.jpeg";